import {Typography} from "@mui/material";
import React from "react";
import {formatDateWithoutTimeZone, timeFormatter,convertDateToTimezone} from "../../../../../../helper/helper";
import {formatTimeDuration} from "../helper";
import moment from "moment-timezone";


export function GuestTransactionStopDate({ row }) {
  const { stopDate, timezone } = row ;
  const convertedDateTime = convertDateToTimezone(stopDate, timezone);

  if (!convertedDateTime) return "";

  const formattedDate = convertedDateTime.format("YYYY-MM-DD");

  return <Typography variant="caption">{formattedDate}</Typography>;
}


export function GuestTransactionTime({ row }) {
  const { stopDate, timezone } = row ;

  const convertedDateTime = convertDateToTimezone(stopDate, timezone);

  if (!convertedDateTime) return "";

  const formattedTime = convertedDateTime.format("HH:mm");

  return <Typography variant="caption">{formattedTime}</Typography>;
}


export function GuestTransactionDuration(params) {
    let {row} = params
    let duration=formatTimeDuration(row?.duration || "")
    return <><Typography variant={"caption"}>{duration}</Typography></>
}
export function GuestTransactionKwh(params) {
    let {row} = params
    return <><Typography variant={"caption"}>{row?.powerDelivered}</Typography></>
}